import { get } from 'lodash';

const categories = [
  { name: 'Advice for Employers and Recruiters', id: 23422 },
  { name: 'Career Advice for Job Seekers', id: 23423 },
  { name: 'Industry News and Information', id: 23424 },
  { name: 'Salary, Scholarships and Finances', id: 23425 },
  { name: 'Other', id: 1 }
];

const catName = (cat) => {
  if (typeof cat === 'string') {
    cat = { name: cat };
  }
  return cat.name === 'Uncategorized' ? 'Other' : cat.name;
};

const catNameFromId = (id) => {
  const currentCat = categories.find((cat) => {
    return parseInt(cat.id) === parseInt(id);
  });

  return currentCat ? catName(currentCat) : null;
};

const selectPostCat = (post) => {
  let category = get(post, "_embedded['wp:term'][0][0]");
  if (!category) {
    return null;
  }
  if (category && category.name === 'Uncategorized') {
    // don't use "Uncategorized" if a different category is available
    const firstCat = category;
    category = get(post, "_embedded['wp:term'][0][1]", firstCat);
  }
  category.name = catName(category);
  return category;
};

module.exports = { categories, catName, catNameFromId, selectPostCat };
